import { ApiBase } from "@/api/ApiBase";

export interface DocumentoRecente {
  data: string;
  hora: string;
  tipo: string;
  codigo: string;
  nomeCliente: string;
  numero: string;
  valorLiquido: number;
}

export interface InfoHomeBackoffice {
  totalClientes: number;
  totalFornecedores: number;
  totalProdutos: number;
  totalServicos: number;
  vendasHoje: number;
  documentos: DocumentoRecente[];
  documentosTotais: Record<string, number>;
  totalGeralDocumentosEsteAno: number;
  evolucaoMensalEmissaoDocumentos: number[];
}

export interface ClienteResumo {
  id: number;
  nome: string;
  nomeNif: string;
  nif: string;
}

export interface EstabelecimentoResumo {
  id: number;
  numero: string;
  nome: string;
}

export interface UtilizadorResumo {
  id: number;
  nome: string;
}

export interface InfoPageRelatorio {
  ANO_SELECTED: number;
  anos: number[];

  clientes: ClienteResumo[];
  estabelecimentos: EstabelecimentoResumo[];
  utilizadores: UtilizadorResumo[];

  evolucaoMensalVendas: number[];
  vendasSemestre1: number;
  vendasSemestre2: number;
  totalDocsVendas: number;

  evolucaoMensalImpostos: number[];
  impostosSemestre1: number;
  impostosSemestre2: number;
  totalDocsImpostos: number;

  evolucaoMensalRetencao: number[];
  retencaoSemestre1: number;
  retencaoSemestre2: number;
  totalDocsRetencao: number;

  evolucaoMensalRecibos: number[];
  recibosSemestre1: number;
  recibosSemestre2: number;
  totalDocsRecibos: number;

  evolucaoPropostas: number[];
  valorProformas: number;
  totalDocsProformas: number;
  valorOrcamentos: number;
  totalDocsOrcamentos: number;
  valorGuaisTransporte: number;
  totalDocsGuaisTransporte: number;
  valorGuaisRemessas: number;
  totalDocsGuaisRemessas: number;

  evolucaoMensalReceitas: number[];
  receitasSemestre1: number;
  receitasSemestre2: number;

  evolucaoMensalDespesas: number[];
  despesasSemestre1: number;
  despesasSemestre2: number;
}

export class RelatorioApi extends ApiBase {
  consultaInfoHomeBackoffice(): Promise<InfoHomeBackoffice> {
    return this.http.put<InfoHomeBackoffice>(
      "/api/facturacao/relatorios/consulta-info-home-backoffice",
    );
  }

  consultaInfoPageRelatorio(ano: number): Promise<InfoPageRelatorio> {
    return this.http.put<InfoPageRelatorio>(
      `/api/facturacao/relatorios/consulta-info-page-relatorio/${ano}`,
    );
  }
}
